import {
  insert as publicInsert,
  update as publicUpdate,
  save as publicSave,
  get as publicGet,
  remove as publicRemove,
  truncate as publicTruncate,
  query as publicQuery,
  aggregate as publicAggregate,
  count as publicCount,
  distinct as publicDistinct,
  bulkInsert as publicBulkInsert,
  bulkSave as publicBulkSave,
  bulkUpdate as publicBulkUpdate,
  bulkRemove as publicBulkRemove,
  queryReferenced as publicQueryReferenced,
  bulkInsertReferences as publicBulkInsertReferences,
  bulkReplaceReferences as publicBulkReplaceReferences,
  bulkRemoveReferences as publicBulkRemoveReferences,
  isReferenced as publicIsReferenced,
} from './data-v1-data-service-data.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const insert: MaybeContext<
  BuildRESTFunction<typeof publicInsert> & typeof publicInsert
> = /*#__PURE__*/ createRESTModule(publicInsert);
/** @internal */
export const update: MaybeContext<
  BuildRESTFunction<typeof publicUpdate> & typeof publicUpdate
> = /*#__PURE__*/ createRESTModule(publicUpdate);
/** @internal */
export const save: MaybeContext<
  BuildRESTFunction<typeof publicSave> & typeof publicSave
> = /*#__PURE__*/ createRESTModule(publicSave);
/** @internal */
export const get: MaybeContext<
  BuildRESTFunction<typeof publicGet> & typeof publicGet
> = /*#__PURE__*/ createRESTModule(publicGet);
/** @internal */
export const remove: MaybeContext<
  BuildRESTFunction<typeof publicRemove> & typeof publicRemove
> = /*#__PURE__*/ createRESTModule(publicRemove);
/** @internal */
export const truncate: MaybeContext<
  BuildRESTFunction<typeof publicTruncate> & typeof publicTruncate
> = /*#__PURE__*/ createRESTModule(publicTruncate);
export const query: MaybeContext<
  BuildRESTFunction<typeof publicQuery> & typeof publicQuery
> = /*#__PURE__*/ createRESTModule(publicQuery);
/** @internal */
export const aggregate: MaybeContext<
  BuildRESTFunction<typeof publicAggregate> & typeof publicAggregate
> = /*#__PURE__*/ createRESTModule(publicAggregate);
/** @internal */
export const count: MaybeContext<
  BuildRESTFunction<typeof publicCount> & typeof publicCount
> = /*#__PURE__*/ createRESTModule(publicCount);
/** @internal */
export const distinct: MaybeContext<
  BuildRESTFunction<typeof publicDistinct> & typeof publicDistinct
> = /*#__PURE__*/ createRESTModule(publicDistinct);
/** @internal */
export const bulkInsert: MaybeContext<
  BuildRESTFunction<typeof publicBulkInsert> & typeof publicBulkInsert
> = /*#__PURE__*/ createRESTModule(publicBulkInsert);
/** @internal */
export const bulkSave: MaybeContext<
  BuildRESTFunction<typeof publicBulkSave> & typeof publicBulkSave
> = /*#__PURE__*/ createRESTModule(publicBulkSave);
/** @internal */
export const bulkUpdate: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdate> & typeof publicBulkUpdate
> = /*#__PURE__*/ createRESTModule(publicBulkUpdate);
/** @internal */
export const bulkRemove: MaybeContext<
  BuildRESTFunction<typeof publicBulkRemove> & typeof publicBulkRemove
> = /*#__PURE__*/ createRESTModule(publicBulkRemove);
/** @internal */
export const queryReferenced: MaybeContext<
  BuildRESTFunction<typeof publicQueryReferenced> & typeof publicQueryReferenced
> = /*#__PURE__*/ createRESTModule(publicQueryReferenced);
/** @internal */
export const bulkInsertReferences: MaybeContext<
  BuildRESTFunction<typeof publicBulkInsertReferences> &
    typeof publicBulkInsertReferences
> = /*#__PURE__*/ createRESTModule(publicBulkInsertReferences);
/** @internal */
export const bulkReplaceReferences: MaybeContext<
  BuildRESTFunction<typeof publicBulkReplaceReferences> &
    typeof publicBulkReplaceReferences
> = /*#__PURE__*/ createRESTModule(publicBulkReplaceReferences);
/** @internal */
export const bulkRemoveReferences: MaybeContext<
  BuildRESTFunction<typeof publicBulkRemoveReferences> &
    typeof publicBulkRemoveReferences
> = /*#__PURE__*/ createRESTModule(publicBulkRemoveReferences);
/** @internal */
export const isReferenced: MaybeContext<
  BuildRESTFunction<typeof publicIsReferenced> & typeof publicIsReferenced
> = /*#__PURE__*/ createRESTModule(publicIsReferenced);

export {
  Segment,
  SortOrder,
  Order,
} from './data-v1-data-service-data.universal.js';
export {
  Item,
  InsertRequest,
  Options,
  InsertResponse,
  UpdateRequest,
  UpdateResponse,
  SaveRequest,
  SaveResponse,
  PatchRequest,
  PatchResponse,
  PatchWhereRequest,
  PatchWhereResponse,
  GetRequest,
  ReadOptions,
  GetResponse,
  RemoveRequest,
  RemoveResponse,
  TruncateRequest,
  TruncateResponse,
  QueryRequest,
  Query,
  Sorting,
  Paging,
  QueryV2,
  QueryV2PagingMethodOneOf,
  CursorPaging,
  QueryResponse,
  PagingMetadataV2,
  Cursors,
  AggregationRequest,
  AggregationResponse,
  CountRequest,
  CountResponse,
  DistinctRequest,
  DistinctResponse,
  BulkInsertRequest,
  BulkInsertResponse,
  BulkError,
  ApplicationError,
  Details,
  BulkSaveRequest,
  BulkSaveResponse,
  BulkUpdateRequest,
  BulkUpdateResponse,
  BulkPatchRequest,
  Entry,
  BulkPatchResponse,
  BulkRemoveRequest,
  BulkRemoveRequestEntry,
  BulkRemoveResponse,
  QueryReferencedRequest,
  QueryReferencedResponse,
  ReferencedEntity,
  ReferencedEntityEntityOneOf,
  BulkInsertReferencesRequest,
  Reference,
  BulkInsertReferencesResponse,
  BulkReplaceReferencesRequest,
  BulkReplaceReferencesResponse,
  BulkRemoveReferencesRequest,
  BulkRemoveReferencesResponse,
  IsReferencedRequest,
  IsReferencedResponse,
  RestoreFromTrashBinRequest,
  RestoreFromTrashBinResponse,
  InsertOptions,
  UpdateOptions,
  SaveOptions,
  GetOptions,
  RemoveOptions,
  TruncateOptions,
  QueryOptions,
  AggregateOptions,
  CountOptions,
  DistinctOptions,
  BulkInsertOptions,
  BulkSaveOptions,
  BulkUpdateOptions,
  BulkRemoveOptions,
  QueryReferencedOptions,
  BulkInsertReferencesOptions,
  BulkReplaceReferencesOptions,
  BulkRemoveReferencesOptions,
  IsReferencedOptions,
} from './data-v1-data-service-data.universal.js';
export {
  SegmentWithLiterals,
  SortOrderWithLiterals,
  OrderWithLiterals,
} from './data-v1-data-service-data.universal.js';
